import { useFormik } from 'formik';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import * as moment from "moment";
import { LuChevronRight } from 'react-icons/lu';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { Badge, Box, Button, Flex, Grid, Image, Spinner, Switch, Text, useColorMode } from 'theme-ui';
import * as Yup from 'yup';
import { MediaProps, RootState, usersProps } from '../../../../@types';
import { mediaUpload } from '../../../store/actions/media.action';
import { UpdateStageAttachment, editStageById, getHighlighterByView, getHighlighterByViewSuccess, getSowChecklist, getSowFields, getStagesById, getStagesByIdSuccess, getStageCountsByDate } from '../../../store/actions/project.action';
import { baseUrl } from '../../../utils/global';
import { Inputform } from '../../forms-component/InputForm';
import FormSelect from '../../forms-component/globalSelect';
import StepThreeOnly from '../../project-components/viewTask';
import StageSideActions from './StageSidebar';
import UploadMediaFile from '../../UploadMediaFile/UploadMediaFile';
import { useQuery } from '@tanstack/react-query';
import { ActionHourADay } from '../../Actions/ActionModule/ActionHourADay';
import { ActionModule } from '../../Actions/ActionModule/ActionModule';
import NewDeliveryNotesModal from '../../Actions/ActionModule/NewDeliveryNotesModal';
import ActionBackgroundCheck from '../../Actions/ActionModule/ActionBackgroundCheck';
import { removeHighlightFromStage } from '../../../store/actions/action.Highlighters';
import { debounce } from 'lodash';
import { isDateRestricted } from '../../../utils/dateValidation';
import FolderNumberDropdown from '../createProject/StepOne/folderNumberDropdown';
import { statusColors } from '../../../utils/constent';
import spent from "../../assets/images/Icon/spent.svg";
import plyBtn from "../../pages/TaskView/playBtn.svg";

import theme from '../../../theme';
import GeneralTimerStart from '../TaskView/GeneralTimerModal/GeneralTimerStart';
import queryString from 'query-string';

const DoubleClickModal = ({ isOpen, toggle, highlight, colorMode }: any) => {

    const dispatch = useDispatch();
    const { stageId } = useParams<{ stageId: string }>();

    const handleSwitchChange = () => {
        if (highlight?.name) {
            const payload = {

                highlighterName: highlight.name
            }
            dispatch(removeHighlightFromStage(payload, stageId,));
            toggle();
        }
    };
    //  const [colorMode] = useColorMode();
    const modalHeader = colorMode === 'light' ? "#fff" : "#20283c";
    const titleHeader = colorMode === 'light' ? "#0a0a0a" : "#dadada";
    return (

        <Modal isOpen={isOpen} toggle={toggle} centered >
            <ModalHeader toggle={toggle} style={{ backgroundColor: modalHeader, color: titleHeader }}>Acknowledgement</ModalHeader>
            <ModalBody style={{ backgroundColor: modalHeader, color: titleHeader }}>
                <Box><Switch sx={{ position: 'absolute', top: '17px', right: '8px' }} onChange={handleSwitchChange} /></Box>
                <Text>Are you sure you want to remove Highlighters?</Text>
            </ModalBody>

        </Modal>
    )
};

const EditStageView: React.FC = () => {
    const { stageId } = useParams<{ stageId: string }>();
    const { dataForTable } = useSelector((state: any) => state.masterData);
    const { auther } = useSelector((state: RootState) => state.auth);
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const { highlights } = queryString.parse(location.search);
    const { userData } = useSelector((state: RootState) => state.user);
    const { loader, stagesView, stageCounts } = useSelector(
        (state: any) => state.project
    );
    const projectId = stagesView?.projectId?._id;
    const { uploadedMedia } = useSelector((state: MediaProps) => state?.media);
    const [Open, setOpen] = useState(false);
    const [selectedHighlight, setSelectedHighlight] = useState<any>(null);
    const [highlight, setHighlight] = useState<any>(null);
    const [isModalOpen, setModalOpen] = useState<boolean>(true);
    const [isDoubleClickModalOpen, setDoubleClickModalOpen] = useState<boolean>(false);
    const [modalOpen, issetModalOpen] = useState<boolean>(false);
    const [stageStatus, setStageStatus] = useState<keyof typeof statusColors | "">("");
    const [highlighters, setHighlighters] = useState<object[]>([]);


    const { createHighlight } = useSelector((state: any) => state.actionHighlight);
    const lastCreateHighlightRef = useRef<any>(null);
    const promise = [
        { label: "Select Promise", value: "" },
        { label: "Customer", value: "Customer" },
        { label: "Personal", value: "Personal" },
        { label: "Hot Promise", value: "hotPromise" },

    ];
    const projectManagerOptions = dataForTable?.data?.allProjectManagers?.map((manager: any) => ({
        value: manager?._id,
        label: `${manager?.FirstName} ${manager?.LastName}`
    })) || [];

    const salesReps = (userData?.data || []).filter((user: usersProps) =>
        user?.departments?.some((dept: { name: string }) => dept?.name === 'SALES')
    );
    const salesRepOptions = salesReps.map((rep: usersProps) => ({
        value: rep?._id || '',
        label: `${rep?.FirstName || ''} ${rep?.LastName || ''}`.trim()
    })) || [];


    const dispatch = useDispatch();
    const navigate = useNavigate();

    const clickTimeoutRef = useRef<NodeJS.Timeout | null>(null);
    const stageCountsRef = useRef(stageCounts);
    const autherRef = useRef(auther);

    useEffect(() => {
        stageCountsRef.current = stageCounts;
    }, [stageCounts]);

    useEffect(() => {
        autherRef.current = auther;
    }, [auther]);

    const isDateRestrictedLocal = useCallback((dateValue: any) => {
        return isDateRestricted(
            dateValue,
            stageCountsRef.current,
            (autherRef.current as any)?.priorityDueDateAccess
        );
    }, []);

    const debouncedDispatch = useMemo(() => debounce(
        (fieldName: string, value: any) => {
            if (fieldName === 'dueDate' && isDateRestrictedLocal(value)) {
                console.warn("Internal block: skipping API call for fully booked date");
                return;
            }
            const displayFieldName = fieldName === 'waitingForPayment' ? 'Payment' : fieldName;
            dispatch(editStageById({ [fieldName]: value }, stageId, displayFieldName));
            dispatch(getStageCountsByDate());
        },
        500
    ), [dispatch, stageId, isDateRestrictedLocal]);

    const debounceRequest = useCallback((fieldName: string, value: any) => {
        debouncedDispatch(fieldName, value)
        // eslint-disable-next-line
    }, [debouncedDispatch])


    useEffect(() => {
        return () => {
            debouncedDispatch.cancel()
        }
    }, [debouncedDispatch])


    useEffect(() => {
        if (createHighlight && createHighlight !== lastCreateHighlightRef.current && stageId) {
            lastCreateHighlightRef.current = createHighlight;
            dispatch(getStagesById(stageId));
        }
    }, [createHighlight, dispatch, stageId]);

    useEffect(() => {
        dispatch(getStageCountsByDate());
        dispatch(getStagesById(stageId));
        // dispatch(getHistoryByView(`stageId=${stageId}`))
        dispatch(getSowChecklist());
        dispatch(getSowFields());

    }, [dispatch, stageId]);

    const validationSchema = useMemo(() => Yup.object().shape({
        architect: Yup.string().required('Architect is required'),
        projectManager: Yup.string().required('Project Manager is required'),
        dueDate: Yup.string()
            .nullable()
            .test('high-volume-check', 'Date is fully booked.', (value) => {
                if (!value || (auther as any)?.priorityDueDateAccess) return true;
                const date = (moment as any)(value);
                if (!date.isValid()) return true;
                const dateStr = date.format('YYYY-MM-DD');
                const count = (stageCounts as any)?.[dateStr] || 0;
                return count < 35;
            }),
    }), [stageCounts, auther]);
    useEffect(() => {
        if (stagesView && stagesView.highlighters) {
            setHighlighters(stagesView.highlighters)
        }
    }, [stagesView.highlighters]);

    const toggleStartTimerModal = () => {
        issetModalOpen(!modalOpen);
    };


    const closeModal = () => {
        const prevRoute = sessionStorage.getItem('prevRoute');
        if (params.get('isNotification') === 'true') {
            if (params.get('fromTab') === 'new') {
                navigate('/dashboard');
            } else if (prevRoute) {
                navigate(prevRoute);
                sessionStorage.removeItem('prevRoute');
            } else {
                navigate(-1);
            }
        } else {
            navigate(-1);
        }
        setModalOpen(false);
    };

    const toggleDoubleClickModal = () => {
        setDoubleClickModalOpen(!isDoubleClickModalOpen);
    };
    useEffect(() => {
        if (uploadedMedia !== null) {
            dispatch(getStagesById(stageId));
        }
    }, [uploadedMedia])
    useEffect(() => {
        if (stagesView?.status) {
            setStageStatus(stagesView?.status as keyof typeof statusColors);
        }
    }, [stagesView])
    useEffect(() => {
        dispatch(getHighlighterByView("stage"));
        return () => {
            dispatch(getHighlighterByViewSuccess([]));
            dispatch(getStagesByIdSuccess([]));
        }
    }, [])

    const handleSseChange = (data: { [key: string]: any }) => {
        Object.keys(data)?.forEach((element: string) => {
            if (element === "highlighters") {
                handleHighlightersUpdate(data[element]);
            }
            if (element === "status") {
                setStageStatus(data[element] as keyof typeof statusColors);

                if (stagesView.status !== data[element]) {
                    dispatch(getStagesById(stageId));

                }
            }
            formik.setFieldValue(`${element}`, data[element], true);
        });
    }
    const handleHighlightersUpdate = (data: any) => {
        setHighlighters((prev) => Array.isArray(data) ? [...data] : [])
    }


    const formik = useFormik(
        {
            enableReinitialize: true,
            initialValues: {
                dueDate: stagesView?.dueDate || null,
                clientDueDate: stagesView?.clientDueDate || null,
                manager: stagesView?.manager || null,
                name: stagesView?.name,
                projectId: {
                    _id: stagesView?.projectId?._id,
                    name: stagesView?.projectId?.name
                },
                promise: stagesView?.promise || '',
                folderNumber: stagesView?.projectId?.folderNumber,
                waitingForPayment: stagesView?.waitingForPayment ?? false,
                tasksNameList: [],
                temporaryName: stagesView?.temporaryName || '',
                salesRepresentative:
                    (typeof stagesView?.projectId?.salesRepresentative === 'object'
                        ? stagesView?.projectId?.salesRepresentative?._id
                        : stagesView?.projectId?.salesRepresentative) ||
                    (typeof stagesView?.salesRepresentative === 'object'
                        ? stagesView?.salesRepresentative?._id
                        : (stagesView?.salesRepresentative || null)),
                _id: stagesView?._id
            },
            validationSchema: validationSchema,
            onSubmit: () => { }
        }
    );
    const { handleSubmit, setFieldValue, setFieldTouched, handleChange, handleBlur, touched, values, errors } = formik;

    const commitTemporaryName = (raw = '') => {
        const trimmed = raw.trim();
        setFieldValue('temporaryName', trimmed, true);
        if (trimmed !== (stagesView?.temporaryName || '').trim()) debounceRequest('temporaryName', trimmed);
    };

    const handleProfileImageChange = useCallback((event: any) => {
        const file = event.target.files[0];
        if (file) {
            try {
                const formData = new FormData();
                formData.append('file', file);
                formData.append('type', 'project');
                const data = {
                    stage_id: stageId
                };
                formData.append('data', JSON.stringify(data));
                dispatch(mediaUpload(formData));
            } catch (error) {
                console.error('An error occurred during file upload:', error);
            }
        } else {
            console.warn('Profile Image not found!');
        }
    }, []);
    const handleDrop = useCallback((event: any) => {
        event.preventDefault();
        const files = Array.from(event.dataTransfer.files);
        if (files.length > 0) {
            handleProfileImageChange(files);
        } else {
        }
    }, [handleProfileImageChange]);
    const handleDragOver = useCallback((event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
    }, []);

    // implement Highlight

    const handleHighlightClick = (highlight: any, autoTrigger = false) => {
        if (autoTrigger) {

            const backgroundChangeGroups = ["Background Change Done", "Background Change InProgress", "Background Change"];
            const blockedByTradeGroups = ["Blocked By Trade Completed", "Waiting for Trade"];

            let newSelectedHighlight = { ...highlight };

            if (backgroundChangeGroups.includes(highlight?.name)) {
                newSelectedHighlight = { ...highlight, name: "Background Change" };
            } else if (blockedByTradeGroups.includes(highlight?.name)) {
                newSelectedHighlight = { ...highlight, name: "Blocked By Trade" };
            } else if (highlight?.name === "Needed Info Reply") {
                newSelectedHighlight = { ...highlight, name: "Need Info" };
            }

            setSelectedHighlight(newSelectedHighlight);
            setOpen(true);
            return;
        }

        if (clickTimeoutRef?.current) {
            clearTimeout(clickTimeoutRef?.current);
            clickTimeoutRef.current = null;
            const dblclickHighlights = ['Background Change Done', 'New Info Added', 'Revision', 'Plan Check', 'Need Info', 'Internal Review', 'Hour a Day',
                'Blocked By Trade', 'Todo Per Review', 'Blocked by Info', 'Final Review', 'Delivery Notes', 'Ready To Deliver', ' Deliver', 'Project Setup', 'Blocked By Trade Completed', 'Background Change InProgress', ' Waiting for Payment - FULL', ' Waiting for Payment - PRELIM', 'Waiting for Trade', 'Background Change']
            setHighlight(dblclickHighlights?.includes(highlight?.name) ? { ...highlight } : highlight);
            setDoubleClickModalOpen(true);
            // if (highlight?.name === "Background Change Done" || highlight?.name === "New Info Added" || highlight?.name === "Revision") {
            //     setHighlight(highlight);
            //     setDoubleClickModalOpen(true);
            // }
        } else {
            let newSelectedHighlight = { ...highlight };

            clickTimeoutRef.current = setTimeout(() => {
                clickTimeoutRef.current = null;
                handleHighlightClick(highlight, true);
                const backgroundChangeGroups = ["Background Change Done", "Background Change InProgress", "Background Change"];
                newSelectedHighlight = backgroundChangeGroups?.includes(highlight?.name) ? { ...highlight, name: "Background Change" } : highlight
                setSelectedHighlight(newSelectedHighlight);
                setOpen(true);
            }, 300);
        }
    };

    const customProps_ = {
        selectedHighlight, Open, setOpen, actionObject: { projectId: stagesView?.projectId?._id, stageId: stagesView?._id, taskId: stagesView?.taskId?._id }, activeTab: 0, TaskView: stagesView?.MinTaskData, hourADay: stagesView?.hoursADay, status: stagesView?.status, stageStatus: stagesView?.tasksNameList, openedFrom: "highlighter"
    }
    const cursorPointerGroups = ["Project Setup", "Hour a Day", "Internal Review", 'Todo Per Review', 'Blocked by Info', "Delivery Notes", 'Ready To Deliver', ' Deliver', "Blocked By Trade", 'Blocked By Trade Completed', ' Waiting for Payment - FULL', ' Waiting for Payment - PRELIM', 'Waiting for Trade', "Need Info", "New Info Added", "Final Review", "Plan Check", "Revision", "Background Change", "Background Change Done", "Background Change InProgress",];

    const [colorMode] = useColorMode();
    const modalHeader = colorMode === 'light' ? "#fff" : "#20283c";
    const titleHeader = colorMode === 'light' ? "black" : "#dadada";
    const label = colorMode === 'light' ? "#0a0a0a" : "#dadada";
    useEffect(() => {
        if (highlights && highlighters?.length > 0) {
            // Normalize the highlights param to match real names
            const highlightGroupMap: Record<string, string[]> = {
                "Background Change": ["Background Change InProgress", "Background Change Done"],
            };

            // Try to find actual match
            let matched = highlighters.find((h: any) => h.name === highlights);

            // If no exact match, try matching groupde
            if (!matched) {
                for (const [normalized, realNames] of Object.entries(highlightGroupMap)) {
                    if (normalized === highlights) {
                        matched = highlighters.find((h: any) => realNames.includes(h.name));
                        if (matched) break;
                    }
                }
            }

            if (matched && !Open && selectedHighlight?.name !== (matched as any).name) {
                handleHighlightClick(matched, true);
            }
        }
    }, [highlights, highlighters, Open, selectedHighlight]);


    const { data: eventSource } = useQuery({
        queryKey: ['stageSSE', stageId],
        queryFn: () => {
            const eventSource = new EventSource(`${baseUrl}sse/${stageId}`);

            eventSource.onmessage = (event) => {
                try {
                    const data = JSON.parse(event.data);
                    handleSseChange(data);
                    dispatch(UpdateStageAttachment(data.attachments))
                } catch (error) {
                    console.error('Error parsing SSE data:', error);
                }
            };

            eventSource.onerror = (error) => {
                eventSource.close();
            };
            return eventSource;
        },
        refetchInterval: 60000
    })
    useEffect(() => {
        return () => {
            eventSource?.close();
        };
    }, [eventSource])

    return (
        <>
            <Modal isOpen={isModalOpen} toggle={closeModal} scrollable centered style={{ maxWidth: '93%' }} backdrop={true}>
                <ModalHeader toggle={closeModal} style={{ backgroundColor: modalHeader, color: titleHeader }} >
                    <Grid
                        columns={[2, '1fr auto']}
                        sx={{
                            alignItems: 'center',
                            gap: 2,
                        }}
                    >
                        <h4
                            style={{
                                display: 'flex',
                                gap: '8px',
                                alignItems: 'center',
                                flexWrap: 'wrap',
                            }}
                        >
                            <Link style={{ color: titleHeader }} to={`/edit-project/${stagesView?.projectId?._id}`}>
                                {stagesView?.projectId?.name}
                            </Link>
                            &nbsp; <LuChevronRight />{' '}
                            <Link style={{ color: stagesView?.color }} to={''}>
                                {stagesView.temporaryName ? stagesView.temporaryName : stagesView.name}
                            </Link>
                            {highlighters?.map((badge: any) => (
                                <Badge
                                    key={badge?._id}
                                    color={badge?.color}
                                    sx={{
                                        backgroundColor: 'transparent',
                                        borderRadius: '8px',
                                        gap: '3px',
                                        padding: '4px 8px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        border: `1px solid ${badge?.color}`,
                                        cursor: `${cursorPointerGroups.includes(badge?.name) ? 'pointer' : 'default'}`,
                                    }}
                                    onClick={(e: any) => {
                                        handleHighlightClick(badge);
                                    }}
                                >
                                    {badge?.icon && (
                                        <Image title={badge?.name} src={badge?.icon} alt={badge?.name} width={14} height={14} />
                                    )}
                                    <Text sx={{ color: `${badge?.color}` }}>{badge?.name}</Text>
                                </Badge>
                            ))}
                        </h4>

                        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                            <Button variant="startButton" sx={{ background: modalHeader }} onClick={toggleStartTimerModal}>
                                <img src={spent} alt="" /> Start Tracking <img src={plyBtn} alt="" />
                            </Button>
                            <div>
                                {loader && <Spinner size={30} className="mx-2" />}

                            </div>
                        </div>
                    </Grid>

                    <Box>
                        <Badge
                            sx={{
                                backgroundColor: `${statusColors[stageStatus as keyof typeof statusColors] || `${theme?.colors?.muted}`
                                    }`,
                                border: `1px solid ${statusColors[stageStatus as keyof typeof statusColors] || `${theme?.colors?.muted}`
                                    }`,
                                borderRadius: '8px',
                                padding: '4px 8px',
                                color: '#fff',
                                fontWeight: 'bold',
                                textAlign: 'center',
                            }}
                        >
                            {stageStatus}
                        </Badge>
                    </Box>
                    <GeneralTimerStart isOpen={modalOpen} toggle={toggleStartTimerModal} autherId={auther?._id} stageId={stagesView?._id} projectId={stagesView?.projectId?._id} />

                </ModalHeader>


                <ModalBody className="p-0" style={{ backgroundColor: modalHeader, color: titleHeader }}>
                    <Flex sx={{ flexDirection: 'row' }}>
                        <Box sx={{ width: '70%', pr: 3 }}>
                            {/* <Box className="p-3">
                                <Text variant="SelectLabel">Description</Text>
                                <textarea
                                    className="form-control"
                                    value={getproject?.projectSow?.description}
                                    placeholder="project sow..."
                                    rows={5}

                                />
                            </Box> */}
                            <Grid className="p-3"
                                sx={{ gap: '1rem', marginTop: 3 }}
                                columns={[1, 2, 2, 3, 4, 4]}
                            >

                                <Box>
                                    <Inputform
                                        sx={{ color: label }}
                                        label="Temporary Name"
                                        Placeholder="Temporary name"
                                        Name="temporaryName"
                                        onBlur={(e: React.FocusEvent<HTMLInputElement | HTMLSelectElement>) => {
                                            handleBlur(e);
                                            commitTemporaryName(values.temporaryName);
                                        }}
                                        onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                                            if (e.key === 'Enter') {
                                                commitTemporaryName(values.temporaryName);
                                            }
                                        }}
                                        OnChange={(event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
                                            const rawValue = event.target.value;
                                            if (rawValue.length > 0 && rawValue.trim() === '') return;
                                            const newValue = rawValue.replace(/^\s+/, '');
                                            setFieldValue("temporaryName", newValue, true);
                                        }}
                                        values={values?.temporaryName || ''}
                                    />
                                </Box>
                                <Box>
                                    <Inputform
                                        inputClassName="custom-datepicker-input"
                                        wrapperClassName="date-input-wrapper"
                                        sx={{ color: label, dayCounts: stageCounts || {} }}
                                        type="date"
                                        label="Due Date"
                                        touched={touched?.dueDate}
                                        errors={errors?.dueDate}
                                        onBlur={handleBlur}
                                        Name={`dueDate`}
                                        OnChange={(event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
                                            const newDate = event.target.value;
                                            setFieldTouched("dueDate", true, false);
                                            setFieldValue("dueDate", newDate || null, true);
                                            if (isDateRestrictedLocal(newDate)) {
                                                console.warn("Blocked and canceled pending API calls for red due date");
                                                debouncedDispatch.cancel();
                                                return;
                                            }
                                            debounceRequest('dueDate', newDate || null);
                                        }}
                                        values={values?.dueDate?.split('T')[0] || ''}
                                        Placeholder="mm/dd/yyyy"
                                    />
                                </Box>
                                <Box>
                                    <FormSelect
                                        sx={{ color: label }}

                                        label={"Promise:"}
                                        value={values?.promise || ''}
                                        placeholder={"Select Promise"}
                                        styles={{
                                            control: (base: any, state: any) => ({
                                                ...base,
                                                backgroundColor: colorMode === 'light' ? '#ffffff' : '#20283c',
                                                borderColor: state.isFocused ? '#ccc' : base.borderColor,
                                                boxShadow: state.isFocused ? '0 0 0 1px rgba(0,0,0,0.06)' : base.boxShadow,
                                                color: label,
                                            }),
                                            valueContainer: (base: any) => ({ ...base, color: label }),
                                            singleValue: (base: any) => ({ ...base, color: label }),
                                            placeholder: (base: any) => ({ ...base, color: label }),
                                            menu: (base: any) => ({
                                                ...base,
                                                backgroundColor: colorMode === 'light' ? '#ffffff' : '#323c56',
                                            }),
                                            menuList: (base: any) => ({
                                                ...base,
                                                backgroundColor: colorMode === 'light' ? '#ffffff' : '#323c56',
                                                color: label,
                                            }),
                                            option: (base: any, { isFocused, isSelected }: any) => ({
                                                ...base,
                                                backgroundColor: isSelected
                                                    ? 'rgba(197,136,136,0.12)'
                                                    : isFocused
                                                        ? 'rgba(255,224,206,0.08)'
                                                        : 'transparent',
                                                color: label,
                                            }),
                                            menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
                                        }}

                                        options={promise || []}
                                        isMulti={false}
                                        // disabled={true}
                                        DefultSelect='Select Promise'
                                        touched={touched?.promise}
                                        errors={errors?.promise}
                                        onBlur={handleBlur}
                                        Name='promise'
                                        onChange={(selectedOption: { value: string; label: string } | null) => {
                                            setFieldValue("promise", selectedOption?.value || '', true);
                                            debounceRequest('promise', selectedOption?.value || '');
                                        }}
                                    // onChange={(values: any) => { setFieldValue("projectWorker", values?.value, true) }}
                                    />
                                </Box>

                                <Box>
                                    <FormSelect
                                        label={"Sales Representative:"}
                                        value={
                                            salesReps.some((r: usersProps) => r._id === (typeof values?.salesRepresentative === 'object' ? (values?.salesRepresentative as unknown as usersProps)?._id : values?.salesRepresentative))
                                                ? (typeof values?.salesRepresentative === 'object' ? (values?.salesRepresentative as unknown as usersProps)?._id : values?.salesRepresentative)
                                                : null
                                        }
                                        placeholder={"Select Sales Representative"}
                                        options={[
                                            { value: '', label: 'Select Sales Representative' },
                                            ...salesRepOptions,
                                        ]}
                                        sx={{ color: label }}
                                        isMulti={false}
                                        DefultSelect='Select Sales Representative'
                                        touched={touched?.salesRepresentative}
                                        errors={errors?.salesRepresentative}
                                        onBlur={handleBlur}
                                        Name='salesRepresentative'
                                        onChange={(selectedRep: { value: string; label: string } | null) => {
                                            setFieldValue("salesRepresentative", selectedRep?.value || null, true);
                                            debounceRequest('salesRepresentative', selectedRep?.value || null);
                                        }}
                                    />
                                </Box>

                                <Box>
                                    <FormSelect
                                        label={"Project Manager:"}
                                        value={
                                            (dataForTable?.data?.allProjectManagers || []).some((x: { _id: string }) => x._id === (typeof values?.manager === 'object' ? (values?.manager as { _id?: string })?._id : values?.manager))
                                                ? (typeof values?.manager === 'object' ? (values?.manager as { _id?: string })?._id : values?.manager)
                                                : null
                                        }
                                        sx={{ color: label }}
                                        placeholder={"Select Project Manager"}
                                        options={[
                                            { value: '', label: 'Select Project Manager' },
                                            ...projectManagerOptions,
                                        ]}
                                        isMulti={false}
                                        DefultSelect='Select Manager'
                                        touched={touched?.manager}
                                        errors={errors?.manager}
                                        onBlur={handleBlur}
                                        Name='manager'
                                        onChange={(selectedWorker: { value: string } | null) => {
                                            setFieldValue("manager", selectedWorker?.value || null, true);
                                            debounceRequest('manager', selectedWorker?.value || null);
                                        }}
                                    />
                                </Box>
                                <Inputform
                                    inputClassName="custom-datepicker-input"
                                    wrapperClassName="date-input-wrapper"
                                    sx={{ color: label }}
                                    type="date"
                                    label="Client Due Date"
                                    onBlur={handleBlur}
                                    Name={`clientDueDate`}
                                    OnChange={(event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
                                        const newDate = event.target.value;
                                        setFieldValue("clientDueDate", newDate || null, true);
                                        debounceRequest('clientDueDate', newDate || null);
                                    }}
                                    values={values?.clientDueDate?.split('T')[0] || ''}
                                    Placeholder="mm/dd/yyyy"
                                />
                                <Box>
                                    <FolderNumberDropdown
                                        label={"Folder Number"}
                                        sx={{ color: label }}
                                        value={values?.folderNumber}
                                        onBlur={handleBlur}
                                        onChange={(selectedFolderNumber: any) => {
                                            setFieldValue("folderNumber", selectedFolderNumber, true);
                                            if (!loader) {
                                                debounceRequest('folderNumber', selectedFolderNumber);
                                            }
                                        }}
                                        // onChange={(selectedFolderNumber) => {
                                        //     setFieldValue("folderNumber", selectedFolderNumber, true);
                                        // }}
                                        disable={true}
                                    />

                                </Box>

                                <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                    <Text sx={{ fontSize: '14px', fontWeight: 500, mb: 1, color: label }}>
                                        Paid
                                    </Text>
                                    <Flex sx={{ alignItems: 'center', height: '38px' }}>
                                        <Switch
                                            checked={Boolean(values?.waitingForPayment)}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                const val = e.target.checked;
                                                setFieldValue('waitingForPayment', val, true);
                                                debounceRequest('waitingForPayment', val);
                                            }}
                                            sx={{
                                                cursor: 'pointer',
                                                'input:checked ~ &': {
                                                    backgroundColor: '#7743DB',
                                                },
                                            }}
                                        />
                                    </Flex>
                                </Box>

                                {/* <Box>
                                    <Text variant="SelectLabel">manager:</Text>
                                    <Select
                                        placeholder="Select Project Manager"
                                        onBlur={handleBlur}
                                        value={projectManagerOptions.find(
                                            (option) => option.value === values.manager
                                        )}
                                        onChange={(selectedOption) => {
                                            setFieldValue(`manager`, selectedOption?.value || '');
                                            updateField('manager', selectedOption?.value);
                                        }}
                                        options={[
                                            { value: '', label: 'Select Manager' },
                                            ...projectManagerOptions,
                                        ]}
                                    />
                                </Box> */}

                            </Grid>
                            {/* <Tab>Stages Lists</Tab> */}
                            <Tabs className="p-3">
                                <TabList>
                                    <Tab id='details'>Details</Tab>
                                    <Tab id='taskList'>Tasks Lists</Tab>
                                </TabList>
                                <TabPanel>
                                    <UploadMediaFile mediaData={stagesView?.attachments || []} typeId={{
                                        stage_id: stageId || '', project_id: projectId || '',
                                    }} type="stage" loader={loader} id={stageId} />
                                </TabPanel>
                                <TabPanel>
                                    <StepThreeOnly projectId={stagesView?.projectId?._id} />
                                </TabPanel>
                            </Tabs>
                        </Box>
                        <StageSideActions isTracking={null} elapsedTime={"00:00:00"} timeTaken={undefined} threads={stagesView?.threads} />
                    </Flex>
                </ModalBody>
            </Modal>

            {selectedHighlight?.name === "Hour a Day" && <ActionHourADay {...customProps_} keys={{ first: "blockingTaskId" }} />}
            {selectedHighlight?.name === "Internal Review" && <ActionModule {...customProps_} keys={{ first: "isChecked" }} />}
            {selectedHighlight?.name === "Delivery Notes" && <NewDeliveryNotesModal showModal={Open} setShowModal={setOpen} {...customProps_} keys={{ first: "isChecked", second: "isInternal", fourth: "toDisplay" }} />}
            {selectedHighlight?.name === "IPR Delivered" && <ActionModule {...customProps_} keys={{ first: "isChecked", second: "isInternal", fourth: "toDisplay" }} />}
            {selectedHighlight?.name === "Deliver" && <ActionModule {...customProps_} keys={{ first: "isChecked", second: "isInternal", fourth: "toDisplay" }} />}
            {selectedHighlight?.name === "Blocked By Trade" && <ActionModule {...customProps_} keys={{ first: "isChecked", second: "blockingTaskId" }} />}
            {selectedHighlight?.name === "New Info Added" && <ActionModule {...customProps_} keys={{ first: "isChecked" }} handleHighlightClick={handleHighlightClick} />}
            {selectedHighlight?.name === "Need Info" && <ActionModule {...customProps_} keys={{ first: "isChecked", second: "isBlockByInfo", fourth: "toDisplay" }} />}
            {selectedHighlight?.name === "Final Review" && <ActionModule {...customProps_} keys={{ first: "isChecked" }} />}
            {selectedHighlight?.name === "Plan Check" && <ActionBackgroundCheck {...customProps_} keys={{ first: "isChecked", second: "isInternal" }} />}
            {selectedHighlight?.name === "Revision" && <ActionBackgroundCheck {...customProps_} keys={{ first: "isChecked", second: "isInternal" }} />}
            {selectedHighlight?.name === "Background Change" && <ActionBackgroundCheck {...customProps_} keys={{ first: "isChecked" }} />}
            {selectedHighlight?.name === "Waiting for Payment" && <ActionModule {...customProps_} />}

            <DoubleClickModal isOpen={isDoubleClickModalOpen} toggle={toggleDoubleClickModal} highlight={highlight} colorMode={colorMode} />

        </>
    );
};

export default EditStageView;
